import { ObjectHelpers } from "../../helpers/object-helpers";

export class HeartStatusDataModel {
    public isLiked = false;
    public tooltip = '';
    
    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}
